import {IInsideOrbitMenuServices} from "../../../../services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {ORBIT_LOCATION_OVERRIDE_BASE} from "../../../../../app-react/services/location/location.service";
import {IInsideOrbitMenuActionInterface} from "../interface/inside-orbit-menu-action.interface";
import {MINI_CIP_BASE_ROUTE} from "../../../../../app-react/services/mini-orbit/mini-orbit-consts";
import {EXIT_CIP, GO_TO_CIP} from "../../inside-orbit-menu-consts/inside-orbit-menu-text.consts";


interface ICipNavigationStrategy {
    readonly text: string;
    navigate(): void;
}

class GoToCipAction implements ICipNavigationStrategy {
    constructor(private services: IInsideOrbitMenuServices) {}
    get text() {
        return GO_TO_CIP;
    }

    navigate() {
        const origin = this.services.window.origin;
        this.services.window.openSelf(origin + MINI_CIP_BASE_ROUTE);
    }
}

class ExitCipAction implements ICipNavigationStrategy {
    constructor(private services: IInsideOrbitMenuServices) {}

    get text() {
        return EXIT_CIP;
    }

    navigate() {
        this.services.storage.removeItem(ORBIT_LOCATION_OVERRIDE_BASE);
        this.services.location.redirect(this.services.location.currentUri.origin);
    }
}

export class CipNavigationMenuAction implements IInsideOrbitMenuActionInterface {
    constructor(private services: IInsideOrbitMenuServices){}

    private get _currentStrategy() {
        if(this.services.storage.getItem(ORBIT_LOCATION_OVERRIDE_BASE) === MINI_CIP_BASE_ROUTE) {
            return new ExitCipAction(this.services);
        } else {
            return new GoToCipAction(this.services);
        }
    }

    get text(): string {
        return this._currentStrategy.text;
    }

    execute = () => {
        this._currentStrategy.navigate();
    }
}